import { CSSProperties, FC, memo } from 'react';

type DotProps = { color: CSSProperties['backgroundColor'] };

const DotComp: FC<DotProps> = ({ color }) => (
  <span className='size-2 rounded-full border-[0.03125rem]' style={{ backgroundColor: color, borderColor: 'rgba(0, 0, 0, 0.1)' }} />
);

export const Dot = memo(DotComp);
